<ng-container *transloco="let t">
    <div fxFill fxLayoutAlign="center center">
        <mat-card appearance="outlined">
            <div fxLayout="column" fxLayoutAlign="space-between center">
                <img
                    src="assets/img/application-icons/success.svg"
                    alt="Success"
                />
                <h2 mat-dialog-title>
                    {{ t("application.success.title") }}
                </h2>
                <div [innerHTML]="client?.confirmationHeaderHtml"></div>
                <div *ngFor="let provider of providerContacts">
                    <p>
                        <a
                            target="_blank"
                            href="{{ provider.webSite }}"
                            rel="noopener"
                            >{{ provider.providerName }}</a
                        ><br />
                        <span
                            *ngIf="
                                provider.address !== null &&
                                provider.address !== ''
                            "
                        >
                            {{ provider.address }}<br />
                        </span>
                        <span
                            *ngIf="
                                provider.contactName !== null &&
                                provider.contactName !== ''
                            "
                        >
                            {{ t("shared.field.contact") }}:
                            {{ provider.contactName }}<br />
                        </span>
                        {{ t("shared.field.phone") }}:
                        {{ provider.contactPhoneNumber }}<br />
                        {{ t("shared.field.email") }}:
                        <a href="mailto: {{ provider.contactEmail }}">{{
                            provider.contactEmail
                        }}</a
                        ><br />
                    </p>
                </div>
                <div [innerHTML]="client?.confirmationFooterHtml"></div>
            </div>
        </mat-card>
    </div>
</ng-container>
